import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

import { COLOR } from '@/globalStyles';

export enum FQTEXT_FIELD_VARIANTS {
    fqTextArea = 'fqTextArea',
}

const FQTextField = styled(TextField, { shouldForwardProp: props => props !== 'data-variant' })(props => {
    switch (props['data-variant']) {
        case FQTEXT_FIELD_VARIANTS.fqTextArea:
            return {
                '& .MuiInputLabel-root:not(.MuiFormLabel-filled)': {
                    paddingLeft: '0.7rem',
                },
                '& .MuiInputBase-root': {
                    padding: '1rem 1.5rem',

                    '.MuiOutlinedInput-notchedOutline': {
                        border: `1px solid ${COLOR.dirtyWhite}`,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        border: `1px solid ${COLOR.ghost}`,
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        border: `1px solid ${COLOR.suvaGrey}`,
                    },
                    '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                        cursor: 'not-allowed',
                        backgroundColor: COLOR.snow,
                    },
                },
            };
        default:
            return {};
    }
});

export default FQTextField;
